import { Stack, Autocomplete, TextField, Typography, IconButton } from "@mui/material";
import { v4 as uuidv4 } from 'uuid';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import { Fragment } from "react";

export const FormService = ({ formValues, handleInputChange, dataProduct }) => {
    const { product: productList } = formValues;

    const handleChangeInput = (id, event) => {
        const newInputFields = productList?.map(i => {
            if (id === i.id) {
                i[event.target.name] = event.target.value
            }
            return i;
        })
        handleInputChange({ 'target': { 'name': 'product', 'value': newInputFields } })
    }

    const handleAddFields = () => {
        handleInputChange({ 'target': { 'name': 'product', 'value': [...productList, { id: uuidv4(), product: '', amount: '', priceProduct: '' }] } })
    }

    const handleRemoveFields = id => {
        const values = [...productList];
        values.splice(values.findIndex(value => value.id === id), 1);
        handleInputChange({ 'target': { 'name': 'product', 'value': values } })
    }

    return (
        <Stack flexDirection='row' width='100%' spacing={1} flexWrap='wrap' justifyContent='space-around' gap={1}>
            <Stack width='100%'>
                <Typography textAlign='center' variant="subtitle" color="primary">Servicios</Typography>
            </Stack>
            {
                productList?.map(inputField => (
                    <Fragment key={inputField.id}>
                        <Stack flexDirection='row' width='90%' justifyContent='space-between' flexWrap='wrap' >
                            <Autocomplete
                                disablePortal
                                options={dataProduct?.filter(d => d.type === 'Servicio').map((d) => d.product).concat('') || ['Cargando productos']}
                                sx={{ width: 350 }}
                                size='small'
                                renderInput={(params) => <TextField name='product'{...params} value={inputField.product} label="Producto" required variant="standard" />}
                                onSelect={event => handleChangeInput(inputField.id, event)}
                                value={dataProduct?.filter(d => d.type === 'Servicio').map((d) => d.product).concat('').includes(inputField.product) ? inputField.product : ''}
                                required
                            />
                            <Autocomplete
                                disablePortal
                                options={['m2', 'ud', 'm3', '']}
                                sx={{ width: 130 }}
                                size='small'
                                renderInput={(params) => <TextField name='measure'{...params} label="Unidad" required variant="standard" />}
                                onSelect={event => handleChangeInput(inputField.id, event)}
                                value={['m2', 'ud'].includes(inputField.measure) ? inputField.measure : ''}
                            />
                            <TextField
                                name="amount"
                                label="Cantidad"
                                variant="standard"
                                value={inputField.amount}
                                onChange={event => handleChangeInput(inputField.id, event)}
                                type="number"
                                InputProps={{ inputProps: { min: 0 } }}
                                sx={{ width: '100px' }}
                                required
                            />
                            <TextField
                                name="priceProduct"
                                label="Precio/ud"
                                variant="standard"
                                value={inputField.priceProduct}
                                onChange={event => handleChangeInput(inputField.id, event)}
                                type="number"
                                InputProps={{ inputProps: { inputMode: "decimal" } }}
                                sx={{ width: '100px' }}
                                required
                            />
                            <IconButton disabled={productList.length === 1} onClick={() => handleRemoveFields(inputField.id)}>
                                <DeleteIcon color='primary' />
                            </IconButton>
                            <IconButton
                                onClick={handleAddFields}
                            >
                                <AddIcon />
                            </IconButton>
                        </Stack>
                    </Fragment>
                ))}
        </Stack>
    )
}